<!-- 流程监控界面 -->
<template>
  <div class="access-record-container">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <!-- 右侧表格 -->
        <div class="section-main_table" style="flex-direction: column">
          <!-- 查询条件 -->
          <div class="query">
            <el-form
              style="margin-top: 10px; transition: all 200ms"
              :class="showSearch ? 'expand searchContent' : 'up searchContent'"
              :inline="true"
              ref="search-form"
              label-position="right"
              label-width="90px"
              :model="searchForm"
            >
              <el-form-item label="预约园区">
                <el-select
                  v-model="searchForm.appointmentPark"
                  placeholder="请选择"
                  style="width: 200px"
                >
                  <el-option
                    v-for="item in parkOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="司机姓名">
                <el-input
                  v-model="searchForm.driverName"
                  style="width: 200px"
                ></el-input>
              </el-form-item>
              <el-form-item label="前车车牌">
                <el-input
                  v-model="searchForm.frontPlate"
                  style="width: 200px"
                />
              </el-form-item>
              <el-form-item label="柜号">
                <el-input v-model="searchForm.cabinetNo" style="width: 200px" />
              </el-form-item>
              <el-form-item label="手机号">
                <el-input v-model="searchForm.phone" style="width: 200px" />
              </el-form-item>
              <el-form-item label="状态">
                <el-select
                  v-model="searchForm.workStatus"
                  placeholder="请选择"
                  style="width: 200px"
                >
                  <el-option
                    v-for="item in appointmentStatusOps"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <div> -->
              <el-form-item label="作业类型">
                <el-select
                  multiple
                  v-model="selectedType"
                  placeholder="请选择"
                  style="width: 200px"
                >
                  <el-option
                    v-for="item in zyTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="操作类型" v-if="selectedType.includes('3')">
                <el-select
                  multiple
                  v-model="selectedOperateType"
                  placeholder="请选择"
                  style="width: 200px"
                >
                  <el-option
                    v-for="item in czTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="预约日期">
                <el-date-picker
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  start-placeholder="选择预约开始日期"
                  end-placeholder="选择预约结束日期"
                  v-model="dateRange"
                  style="width: 300px"
                ></el-date-picker>
              </el-form-item>
              <!-- </div> -->
            </el-form>

            <div>
              <el-button type="primary" @click="searchResult"
                >{{ $t("accountGroup.button.query") }}
              </el-button>
              <el-button type="info" @click="resetQuery"
                >{{ $t("accountGroup.button.reset") }}
              </el-button>
              <el-button
                type="text"
                size="medium"
                v-show="showExpandBtn"
                @click="showSearch = !showSearch"
                :icon="showSearch ? 'el-icon-arrow-up ' : 'el-icon-arrow-down'"
                style="color: #407aee"
                >{{ !showSearch ? "展开" : "收起" }}
              </el-button>
            </div>
          </div>

          <div style="display: grid; height: 0; flex: 1">
            <ioc-table
              ref="unApprovalTab"
              :data="tableData"
              :option="tableOption"
              :page="page"
              @current-change="selectPage"
              @size-change="changeSize"
              style="width: 100%"
            >
              <!-- 状态 -->
              <!-- <template slot="workflow" slot-scope="scope">
                <span>{{ showNameByStatus(scope.row.workflow.status) }}</span>
              </template> -->
              <template slot="menu" slot-scope="scope">
                <el-tooltip
                  v-if="filterStatus(scope.row)"
                  class="item"
                  effect="dark"
                  content="流程回退"
                  placement="top"
                  popper-class="tooltip-draw"
                  style="font-size: 18px"
                >
                  <el-button
                    type="text"
                    icon="el-icon-refresh-left"
                    @click="handelProcessBack(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  v-if="filterStatus(scope.row)"
                  class="item"
                  effect="dark"
                  content="流程终止"
                  placement="top"
                  popper-class="tooltip-draw"
                  style="font-size: 18px"
                >
                  <el-button
                    type="text"
                    icon="el-icon-video-pause"
                    @click="handelProcessDiscontinue(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="详情"
                  placement="top"
                  popper-class="tooltip-draw"
                  style="font-size: 18px"
                >
                  <el-button
                    type="text"
                    icon="el-icon-view"
                    @click="handleView(scope.row, scope.index)"
                  ></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
      </div>
    </div>
    <!--详情-->
    <appPanel
      :width="750"
      class="app-panel"
      :isExpand="showPanel"
      @cancel="handleClosePanel"
      title="流程监控详情"
    >
      <h3>基础信息</h3>
      <div class="panel-content">
        <el-card style="margin: 15px 20px 15px 10px">
          <el-form
            :inline="true"
            :model="approvalDetailInfo"
            label-width="110px"
            label-position="right"
            label-suffix=" :"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="司机姓名">{{
                  approvalDetailInfo.driverName
                    ? approvalDetailInfo.driverName
                    : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="手机号">{{
                  approvalDetailInfo.phone ? approvalDetailInfo.phone : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="客户名称">{{
                  approvalDetailInfo.custom ? approvalDetailInfo.custom : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="前车车牌">{{
                  approvalDetailInfo.frontPlate
                    ? approvalDetailInfo.frontPlate
                    : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="后车车牌">{{
                  approvalDetailInfo.trailerPlate
                    ? approvalDetailInfo.trailerPlate
                    : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="车长">{{
                  approvalDetailInfo.vehicleLong
                    ? approvalDetailInfo.vehicleLong
                    : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="公司名称">{{
                  approvalDetailInfo.companyName
                    ? approvalDetailInfo.companyName
                    : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="园区">{{
                  approvalDetailInfo.appointmentParkName
                    ? approvalDetailInfo.appointmentParkName
                    : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12" class="basic-status-box">
                <el-form-item label="状态">
                  <div>
                    {{
                      approvalDetailInfo.appointmentStatusName
                        ? approvalDetailInfo.appointmentStatusName
                        : "暂无"
                    }}
                  </div>
                </el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="数据来源">{{
                  approvalDetailInfo.dataSource
                    ? approvalDetailInfo.dataSource == "1"
                      ? "客服录入"
                      : approvalDetailInfo.dataSource == "0"
                      ? "司机预约"
                      : "暂无"
                    : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="是否特殊商品">{{
                  approvalDetailInfo.specialProductFlag
                    ? approvalDetailInfo.specialProductFlag == 1
                      ? "是"
                      : approvalDetailInfo.specialProductFlag == 0
                      ? "否"
                      : "暂无"
                    : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="是否暂停作业">{{
                  approvalDetailInfo.isPauseWork
                    ? approvalDetailInfo.isPauseWork == 1
                      ? "是"
                      : approvalDetailInfo.isPauseWork == 0
                      ? "否"
                      : "暂无"
                    : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="回退原因">{{
                  approvalDetailInfo.fallbackReason
                    ? approvalDetailInfo.fallbackReason
                    : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="作业类型">{{
                  approvalDetailInfo.operateType
                    ? approvalDetailInfo.operateType == "1"
                      ? "装货"
                      : approvalDetailInfo.operateType == "2"
                      ? "卸货"
                      : approvalDetailInfo.operateType == "3"
                      ? "过车"
                      : "暂无"
                    : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row v-if="approvalDetailInfo.operateType == '3'">
              <el-col :span="12">
                <el-form-item label="操作类型">{{
                  approvalDetailInfo.passType
                    ? approvalDetailInfo.passType == "1"
                      ? "倒入"
                      : approvalDetailInfo.passType == "2"
                      ? "倒出"
                      : "暂无"
                    : "未识别"
                }}</el-form-item></el-col
              >
            </el-row>
          </el-form>
        </el-card>
        <!-- 货物信息 -->
        <h3>货物信息</h3>
        <el-card style="margin: 15px 20px 15px 10px">
          <el-table
            border
            :data="cabinetData"
            style="overflow-y: auto; max-height: 300px"
          >
            <el-table-column label="序号" width="80">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="waresName"
              label="货物名称"
            ></el-table-column>
            <el-table-column prop="waresCount" label="数量"></el-table-column>
            <el-table-column
              prop="cabinetNumber"
              label="柜号"
            ></el-table-column>
            <template slot="empty"><dataEmpty /></template>
          </el-table>
        </el-card>
        <!-- 入园信息 -->
        <h3>入园信息</h3>
        <el-card style="margin: 15px 20px 15px 10px">
          <el-form
            :inline="true"
            :model="approvalDetailInfo"
            label-width="120px"
            label-position="right"
            label-suffix=" :"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="申请时间">{{
                  approvalDetailInfo.createTime
                    ? approvalDetailInfo.createTime
                    : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="预计到达时间">{{
                  approvalDetailInfo.estimatedArrivalTime
                    ? approvalDetailInfo.estimatedArrivalTime
                    : "暂无"
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="inParkObj.createTime || inParkObj.createName">
              <el-col :span="12">
                <el-form-item label="调度">
                  {{ inParkObj.createName ? inParkObj.createName : "暂无" }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="调度入园审批时间">{{
                  inParkObj.createTime ? inParkObj.createTime : "暂无"
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row class="img-info-box">
              <el-col :span="12">
                <el-form-item label="驾驶证">
                  <div>
                    <img
                      style="
                        width: 150px;
                        height: 150px;
                        cursor: pointer;
                        position: absolute;
                      "
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="getImgPath(approvalDetailInfo.driverLicense)"
                      @click="showViewer(approvalDetailInfo.driverLicense)"
                    />
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="行驶证">
                  <div>
                    <img
                      style="
                        width: 150px;
                        height: 150px;
                        cursor: pointer;
                        position: absolute;
                      "
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="getImgPath(approvalDetailInfo.drivingLicense)"
                      @click="showViewer(approvalDetailInfo.drivingLicense)"
                    />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="img-info-box">
              <el-col :span="12">
                <el-form-item label="前车车牌照片">
                  <div>
                    <img
                      style="
                        width: 150px;
                        height: 150px;
                        cursor: pointer;
                        position: absolute;
                      "
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="
                        getImgPath(
                          approvalDetailInfo &&
                            approvalDetailInfo.frontLicensePlatePicture
                        )
                      "
                      @click="
                        showViewer(
                          approvalDetailInfo &&
                            approvalDetailInfo.frontLicensePlatePicture
                        )
                      "
                    />
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="挂车牌照片">
                  <div>
                    <img
                      style="
                        width: 150px;
                        height: 150px;
                        cursor: pointer;
                        position: absolute;
                      "
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="
                        getImgPath(
                          approvalDetailInfo &&
                            approvalDetailInfo.trailerLicensePlatePicture
                        )
                      "
                      @click="
                        showViewer(
                          approvalDetailInfo &&
                            approvalDetailInfo.trailerLicensePlatePicture
                        )
                      "
                    />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
        <!-- 作业信息 -->
        <h3
          v-if="
            (approvalDetailInfo.appointmentStatus >= 6 &&
              approvalDetailInfo.appointmentStatus <= 10) ||
            approvalDetailInfo.appointmentStatus == 99
          "
        >
          作业信息
        </h3>
        <el-card
          v-if="
            (approvalDetailInfo.appointmentStatus >= 6 &&
              approvalDetailInfo.appointmentStatus <= 10) ||
            approvalDetailInfo.appointmentStatus == 99
          "
          style="margin: 15px 20px 15px 10px"
        >
          <el-table
            stripe
            :data="cabinetData"
            style="overflow-y: auto; margin: 0 auto; max-height: 300px"
          >
            <el-table-column label="序号" width="80">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="waresName"
              label="货物名称"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="waresCount"
              label="数量"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="cabinetNumber"
              label="柜号"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="platformName"
              label="月台"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="operatorName"
              label="库管"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="startWorkTime"
              label="开始时间"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="finishWorkTime"
              label="结束时间"
              width="180"
            ></el-table-column>
            <el-table-column prop="workImg" label="作业图片" width="100">
              <template slot-scope="scope">
                <img
                  style="
                    width: 20px;
                    height: 20px;
                    cursor: pointer;
                    position: absolute;
                    left: 30%;
                    top: 20%;
                  "
                  onerror="this.src='/images/theme/newDark/default.png'"
                  :src="getImgPath(scope.row.workImg)"
                  @click="showViewer(scope.row.workImg)"
                />
              </template>
            </el-table-column>
            <template slot="empty"><dataEmpty /></template>
          </el-table>
        </el-card>
        <!-- 出园信息 -->
        <h3
          v-if="
            (approvalDetailInfo.appointmentStatus >= 8 &&
              approvalDetailInfo.appointmentStatus <= 10) ||
            approvalDetailInfo.appointmentStatus == 99
          "
        >
          出园信息
        </h3>
        <el-card
          v-if="
            (approvalDetailInfo.appointmentStatus >= 8 &&
              approvalDetailInfo.appointmentStatus <= 10) ||
            approvalDetailInfo.appointmentStatus == 99
          "
          style="margin: 15px 20px 15px 10px"
        >
          <el-form
            :inline="true"
            :model="exitParkObj"
            label-width="110px"
            label-position="right"
            label-suffix=" :"
          >
            <el-row v-if="approvalDetailInfo.appointmentStatus >= 8">
              <el-col :span="12">
                <el-form-item label="客服">
                  {{
                    exitParkObj.customerService
                      ? exitParkObj.customerService
                      : "暂无"
                  }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="客服审批时间">
                  {{
                    exitParkObj.customerServiceTime
                      ? exitParkObj.customerServiceTime
                      : "暂无"
                  }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="approvalDetailInfo.appointmentStatus >= 9">
              <el-col :span="12">
                <el-form-item label="调度">
                  {{ exitParkObj.dispatch ? exitParkObj.dispatch : "暂无" }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="调度审批时间">
                  {{
                    exitParkObj.dispatchTime ? exitParkObj.dispatchTime : "暂无"
                  }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="approvalDetailInfo.appointmentStatus >= 10">
              <el-col :span="12">
                <el-form-item label="门卫">
                  {{ exitParkObj.doorman ? exitParkObj.doorman : "暂无" }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="门卫放行时间">
                  {{
                    exitParkObj.doormanTime ? exitParkObj.doormanTime : "暂无"
                  }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              class="img-info-box"
              v-if="approvalDetailInfo.appointmentStatus >= 10"
            >
              <el-col :span="12">
                <el-form-item label="门卫放行拍照">
                  <div>
                    <img
                      style="
                        width: 150px;
                        height: 150px;
                        cursor: pointer;
                        position: absolute;
                      "
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="getImgPath(exitParkObj && exitParkObj.doormanPic)"
                      @click="showViewer(exitParkObj && exitParkObj.doormanPic)"
                    />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>

        <!-- 流程节点 -->
        <h3>流程节点</h3>
        <div style="width: 100%; margin-top: 20px">
          <el-card style="margin: 15px 20px 15px 10px">
            <processNode :nodeArr="nodeArr"></processNode>
          </el-card>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="handleClosePanel">关闭</el-button>
      </div>
    </appPanel>
    <!-- 流程终止-- 弹窗 -->
    <el-dialog
      title="流程终止确认"
      :append-to-body="true"
      :visible.sync="dialogDiscontinueReview"
      width="60vw"
      class="choose-container"
      @close="cancelDiscontinueReview"
    >
      <div
        style="
          height: 11vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
      >
        <el-form
          :inline="true"
          ref="refDiscontinueForm"
          label-position="right"
          label-width="90px"
          :model="discontinueForm"
          :rules="discontinueRule"
        >
          <el-form-item label="终止原因" prop="remark">
            <el-input
              v-model="discontinueForm.remark"
              type="textarea"
              :rows="2"
              placeholder="请输入终止原因"
              style="width: 48vw"
            />
          </el-form-item>
        </el-form>
        <!-- 提示 -->
        <div
          v-if="
            discontinueProcessTips.operateType == '3' &&
            !!discontinueProcessTips.refAppointmentUuid
          "
          style="color: red; width: 96%; margin: 0 auto"
        >
          *&nbsp;存在相关联的过车{{
            discontinueProcessTips.passType == "1"
              ? "倒出"
              : discontinueProcessTips.passType == "2"
              ? "倒入"
              : ""
          }}
          预约单，需要手动同步终止流程。
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelDiscontinueReview">取消</el-button>
        <el-button type="primary" @click="confirmDiscontinueReview"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 流程回退-- 弹窗 -->
    <el-dialog
      title="确认回退该节点"
      :append-to-body="true"
      :visible.sync="dialogRollbackNode"
      width="60vw"
      class="choose-container"
      @close="cancelRollbackCurrNode"
    >
      <div style="height: 10vh">
        <el-form
          :inline="true"
          ref="refRollbackForm"
          label-position="right"
          label-width="120px"
          :model="rollbackForm"
          :rules="rollbackRule"
        >
          <el-form-item label="回退该节点原因" prop="remark">
            <el-input
              v-model="rollbackForm.remark"
              type="textarea"
              :rows="2"
              placeholder="请输入回退该节点原因"
              style="width: 48vw"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelRollbackCurrNode">取消</el-button>
        <el-button type="primary" @click="confirmRollbackCurrNode"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 流程回退确认 --弹窗 -->
    <el-dialog
      title="流程回退确认"
      :append-to-body="true"
      :visible.sync="dialogProcessRollback"
      width="60vw"
      class="choose-container"
      @close="cancelProcessRollback"
    >
      <div style="max-height: 65vh; overflow-y: auto">
        <processNode
          :nodeArr="processRollbackArr"
          :isBack="true"
          @processRollback="processRollbackOpt"
        ></processNode>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelProcessRollback">取消</el-button>
        <el-button type="primary" @click="confirmProcessRollback"
          >确定</el-button
        >
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api";
import appPanel from "@src/components/business/app-panel/index";
import dataEmpty from "@src/components/common/ioc-component/app-data-empty.vue";
import processNode from "../components/ProcessNode.vue";
import { Dic, Bus, Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../const/table";
export default {
  components: {
    appPanel,
    dataEmpty,
    processNode,
  },
  computed: {
    filterStatus() {
      return (row) => {
        if (
          row.appointmentStatus === 1 ||
          row.appointmentStatus === 10 ||
          (row.appointmentStatus > 90 && row.appointmentStatus !== 99)
        ) {
          return false;
        } else {
          return true;
        }
      };
    },
  },
  data() {
    return {
      form: {},
      showPanel: false,
      tableOption: tableOption(),
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],

      // 选择的作业类型
      selectedType: [],
      zyTypeOptions: [
        {
          label: "装货",
          value: "1",
        },
        {
          label: "卸货",
          value: "2",
        },
        {
          label: "过车",
          value: "3",
        },
      ],
      // 选择的操作类型
      selectedOperateType: [],
      czTypeOptions: [
        {
          label: "倒入",
          value: "1",
        },
        {
          label: "倒出",
          value: "2",
        },
      ],
      dateRange: [],
      searchForm: {
        appointmentPark: null,
        startPlanArrivalTime: null,
        endPlanArrivalTime: null,
        driverName: null,
        frontPlate: null,
        workStatus: null, // 状态
        operateTypes: null, // 作业类型
        passTypes: null, // 操作类型
        cabinetNo: null,
        phone: null,
      },
      showExpandBtn: false,
      showSearch: true,
      // 下拉选项
      parkOptions: [
        {
          label: "天津优合进出口有限公司",
          value: "200000001",
        },
      ],
      // 状态下拉选项
      appointmentStatusOps: {},
      // 详情数据
      approvalDetailInfo: {},
      cabinetData: [],
      // 出园信息
      exitParkObj: {
        customerService: "",
        customerServiceTime: "",
        dispatch: "",
        dispatchTime: "",
        doorman: "",
        doormanTime: "",
        doormanPic: "",
      },
      // 入园信息
      inParkObj: {
        createTime: "",
        createName: "",
      },
      nodeArr: [],
      // 流程回退
      dialogProcessRollback: false,
      processRollbackObj: { appointmentUuid: "", status: 0, remark: "" },
      processRollbackArr: [],
      dialogRollbackNode: false,
      rollbackForm: {
        remark: "",
      },
      rollbackRule: {
        remark: {
          required: true,
          message: "请输入回退该节点原因",
          trigger: ["blur", "change"],
        },
      },
      // 流程终止
      dialogDiscontinueReview: false,
      discontinueObj: { appointmentUuid: "", remark: "" },
      discontinueProcessTips: {
        refAppointmentUuid: "",
        operateType: "",
        passType: "",
      },
      discontinueForm: {
        remark: "",
      },
      discontinueRule: {
        remark: {
          required: true,
          message: "请输入拒绝原因",
          trigger: ["blur", "change"],
        },
      },
    };
  },
  beforeDestroy() {},
  created() {},
  mounted() {
    this.getProcessList();
    this.animation();
    // 初始化枚举值
    // this.initAppointStatusOps();
    this.initStatusOps();
  },
  methods: {
    getImgPath(item) {
      return item ? Bus.imgPath(item.split(",")[0]) : "";
    },
    showViewer(item) {
      console.log("-----------------", item);
      if (!item) return;
      console.log("----------2-------", item);
      this.$app.AppInstance.handleShowViewer(
        item.split(",").map((o) => this.getImgPath(o))
      );
    },
    animation() {
      let that = this;
      let domAry =
        document.querySelector(".searchContent") &&
        document.querySelector(".searchContent").children;
      console.log("--谷峰平--domAry:-", domAry);
      if (!domAry) {
        return;
      }
      window.onresize = function () {
        that.animation();
      };
      if (domAry[domAry.length - 1].offsetTop != domAry[0].offsetTop) {
        console.log("--00--");
        this.showExpandBtn = true;
      } else {
        console.log("--111--");
        this.showExpandBtn = false;
      }
    },

    showNameByStatus(pStatus) {
      if (pStatus == "0") {
        return "已申请";
      } else if (pStatus == "1") {
        return "待审批";
      } else if (pStatus == "2") {
        return "已通过";
      } else if (pStatus == "3") {
        return "待签到";
      } else if (pStatus == "4") {
        return "已签到";
      } else if (pStatus == "5") {
        return "待调度";
      } else if (pStatus == "6") {
        return "已调度";
      } else if (pStatus == "7") {
        return "待作业";
      } else if (pStatus == "8") {
        return "作业中";
      } else if (pStatus == "9") {
        return "已完成作业";
      } else if (pStatus == "10") {
        return "待客服押车不放行";
      } else if (pStatus == "17") {
        return "客服已押车不放行";
      } else if (pStatus == "18") {
        return "客服不押车已放行";
      } else if (pStatus == "19") {
        return "客服已解压车";
      } else if (pStatus == "20") {
        return "客服待解压车";
      } else if (pStatus == "26") {
        return "待客服不押车放行";
      } else if (pStatus == "27") {
        return "待调度不押车放行";
      } else if (pStatus == "11") {
        return "客服出园待审批";
      } else if (pStatus == "12") {
        return "客服出园审批已完成";
      } else if (pStatus == "13") {
        return "调度出园待审批";
      } else if (pStatus == "14") {
        return "调度出园审批已完成";
      } else if (pStatus == "15") {
        return "待出园";
      } else if (pStatus == "16") {
        return "已出园";
      } else if (pStatus == "21") {
        return "待调度押车不放行";
      } else if (pStatus == "22") {
        return "调度已押车不放行";
      } else if (pStatus == "23") {
        return "调度不押车已放行";
      } else if (pStatus == "24") {
        return "调度待解压车";
      } else if (pStatus == "25") {
        return "调度已解压车";
      } else if (pStatus == "96") {
        return "已取消";
      } else if (pStatus == "97") {
        return "已拒绝";
      } else if (pStatus == "98") {
        return "已作废";
      } else if (pStatus == "99") {
        return "结束";
      } else if (pStatus == "95") {
        return "异常终止";
      } else {
        return "暂无";
      }
    },
    // 状态枚举值
    initStatusOps() {
      this.appointmentStatusOps = [
        {
          label: "已申请（待审批）",
          value: 1,
        },
        {
          label: "已审批（待签到）",
          value: 2,
        },
        {
          label: "已签到（待作业）",
          value: 3,
        },
        {
          label: "已进入作业",
          value: 5,
        },
        {
          label: "已完成作业（出园客服待审批）",
          value: 61,
        },
        {
          label: "已完成作业（出园调度待审批）",
          value: 62,
        },
        {
          label: "客服已押车（出园客服待审批）",
          value: 7,
        },
        {
          label: "出园客服已审批（出园调度待审批）",
          value: 8,
        },
        {
          label: "出园调度已审批（待放行出园）",
          value: 9,
        },
        {
          label: "已出园",
          value: 10,
        },
        {
          label: "调度已押车（出园调度待审批）",
          value: 11,
        },
        {
          label: "异常终止",
          value: 95,
        },
        {
          label: "已取消",
          value: 96,
        },
        {
          label: "已拒绝",
          value: 97,
        },
        {
          label: "已作废",
          value: 98,
        },
        {
          label: "结束",
          value: 99,
        },
      ];
    },
    // 状态枚举值
    initAppointStatusOps() {
      this.appointmentStatusOps = [
        {
          label: "已申请",
          value: 0,
        },
        {
          label: "待审批",
          value: 1,
        },
        {
          label: "已通过",
          value: 2,
        },
        {
          label: "待签到",
          value: 3,
        },
        {
          label: "已签到",
          value: 4,
        },
        {
          label: "待调度",
          value: 5,
        },
        {
          label: "已调度",
          value: 6,
        },
        {
          label: "待作业",
          value: 7,
        },
        {
          label: "作业中",
          value: 8,
        },
        {
          label: "已完成作业",
          value: 9,
        },
        {
          label: "待客服押车不放行",
          value: 10,
        },
        {
          label: "客服出园待审批",
          value: 11,
        },
        {
          label: "客服出园审批已完成",
          value: 12,
        },
        {
          label: "调度出园待审批",
          value: 13,
        },
        {
          label: "调度出园审批已完成",
          value: 14,
        },
        {
          label: "待出园",
          value: 15,
        },
        {
          label: "已出园",
          value: 16,
        },
        {
          label: "客服已押车不放行",
          value: 17,
        },
        {
          label: "客服不押车已放行",
          value: 18,
        },
        {
          label: "客服已解压车",
          value: 19,
        },
        {
          label: "客服待解压车",
          value: 20,
        },
        {
          label: "待调度押车不放行",
          value: 21,
        },
        {
          label: "调度已押车不放行",
          value: 22,
        },
        {
          label: "调度不押车已放行",
          value: 23,
        },
        {
          label: "调度待解压车",
          value: 24,
        },
        {
          label: "调度已解压车",
          value: 25,
        },
        {
          label: "待客服不押车放行",
          value: 26,
        },
        {
          label: "待调度不押车放行",
          value: 27,
        },
        {
          label: "异常终止",
          value: 95,
        },
        {
          label: "已取消",
          value: 96,
        },
        {
          label: "已拒绝",
          value: 97,
        },
        {
          label: "已作废",
          value: 98,
        },
        {
          label: "结束",
          value: 99,
        },
      ];
    },
    // 获取未审核列表数据
    getProcessList() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.startPlanArrivalTime = this.dateRange[0];
        this.searchForm.endPlanArrivalTime = this.dateRange[1];
      } else {
        this.searchForm.startPlanArrivalTime = null;
        this.searchForm.endPlanArrivalTime = null;
      }

      // 作业类型 operateTypes
      if (!this.selectedType.includes("3")) {
        this.searchForm.passTypes = null;
        this.searchForm.operateTypes = this.selectedType.join(",");
      } else {
        this.searchForm.operateTypes = this.selectedType.join(",");
      }
      // 操作类型
      this.searchForm.passTypes = this.selectedOperateType.join(",");
      const param = {
        ...this.searchForm,
        pageNumber: this.page.currentPage,
        pageSize: this.page.pageSize,
      };

      if (this.searchForm.workStatus == 61) {
        param.workStatus = 6;
        param.operateTypes = this.searchForm.operateTypes
          ? this.searchForm.operateTypes + ",1,3"
          : "1,3";
        param.passTypes = this.searchForm.passTypes
          ? this.searchForm.passTypes + ",2"
          : "2";
      }

      if (param.workStatus == 62) {
        param.workStatus = 6;
        param.operateTypes = this.searchForm.operateTypes
          ? this.searchForm.operateTypes + ",2,3"
          : "2,3";
        param.passTypes = this.searchForm.passTypes
          ? this.searchForm.passTypes + ",1"
          : "1";
      }

      console.log("-------------------------------------");

      this.$fetch(api.queryAppointApprovalList, param).then((res) => {
        if (res.success && res.returnObj.list.length > 0) {
          this.tableData = res.returnObj.list;
          this.page.total = res.returnObj.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
    // 获取已审核列表数据
    getApprovalDoneList() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.startPlanArrivalTime = this.dateRange[0];
        this.searchForm.endPlanArrivalTime = this.dateRange[1];
      } else {
        this.searchForm.startPlanArrivalTime = null;
        this.searchForm.endPlanArrivalTime = null;
      }
      // 作业类型 operateTypes
      if (!this.selectedType.includes("3")) {
        this.searchForm.passTypes = null;
        this.searchForm.operateTypes = this.selectedType.join(",");
      } else {
        this.searchForm.operateTypes = this.selectedType.join(",");
      }
      // 操作类型
      this.searchForm.passTypes = this.selectedOperateType.join(",");
      const param = {
        ...this.searchForm,
        pageNumber: this.approvalDonePage.currentPage,
        pageSize: this.approvalDonePage.pageSize,
      };
      this.$fetch(api.queryAppointApprovalList, param).then((res) => {
        if (res.success && res.returnObj.list.length > 0) {
          this.approvalDoneTableData = res.returnObj.list;
          this.approvalDonePage.total = res.returnObj.total;
        } else {
          this.approvalDoneTableData = [];
          this.approvalDonePage.total = 0;
        }
      });
    },
    handleView(row, index) {
      this.showPanel = true;
      console.log("--车辆详情--row:--", row);
      this.approvalDetailInfo = row;
      // this.cabinetData = row.cabinets;
      // 货物信息
      let cabinets = row.cabinets;
      if (cabinets.length > 0) {
        this.cabinetData = cabinets.map((item) => {
          let newItem = {
            ...item,
            operatorName: "",
            platformId: "",
            status: "",
          };
          if (item.workflows.length > 0) {
            newItem.operatorName = item.workflows[0].operatorName;
            newItem.platformId = item.workflows[0].platformId;
            newItem.status =
              item.workflows[0].status == "7"
                ? "待作业"
                : item.workflows[0].status == "8"
                ? "作业中"
                : item.workflows[0].status == "9"
                ? "已完成"
                : item.workflows[0].status == ""
                ? "未分配"
                : "未分配";
          } else {
            newItem.operatorName = "";
            newItem.platformId = "";
            newItem.status = "";
          }
          return newItem;
        });
      } else {
        this.cabinetData = [];
      }
      // 流程节点信息
      let workflow = row.workflows;
      if (workflow.length > 0) {
        this.nodeArr = workflow.map((item) => {
          let newItem = {
            ...item,
            nodeWay:
              item.status == "0"
                ? "已申请"
                : item.status == "1"
                ? "待审批"
                : item.status == "2"
                ? "已通过"
                : item.status == "3"
                ? "待签到"
                : item.status == "4"
                ? "已签到"
                : item.status == "5"
                ? "待调度"
                : item.status == "6"
                ? "已调度"
                : item.status == "7"
                ? "待作业"
                : item.status == "8"
                ? "作业中"
                : item.status == "9"
                ? "已完成作业"
                : item.status == "10"
                ? "待客服押车不放行"
                : item.status == "17"
                ? "客服已押车不放行"
                : item.status == "18"
                ? "客服不押车已放行"
                : item.status == "19"
                ? "客服已解压车"
                : item.status == "20"
                ? "客服待解压车"
                : item.status == "26"
                ? "待客服不押车放行"
                : item.status == "27"
                ? "待调度不押车放行"
                : item.status == "11"
                ? "客服出园待审批"
                : item.status == "12"
                ? "客服出园审批已完成"
                : item.status == "13"
                ? "调度出园待审批"
                : item.status == "14"
                ? "调度出园审批已完成"
                : item.status == "15"
                ? "待出园"
                : item.status == "16"
                ? "已出园"
                : item.status == "21"
                ? "待调度押车不放行"
                : item.status == "22"
                ? "调度已押车不放行"
                : item.status == "23"
                ? "调度不押车已放行"
                : item.status == "24"
                ? "调度待解压车"
                : item.status == "25"
                ? "调度已解压车"
                : item.status == "96"
                ? "已取消"
                : item.status == "97"
                ? "已拒绝"
                : item.status == "98"
                ? "已作废"
                : item.status == "99"
                ? "结束"
                : item.status == "95"
                ? "异常终止"
                : "暂无",
            nodeName: item.operatorName ? item.operatorName : "暂无",
            nodeDate: item.operateTime ? item.operateTime : "暂无",
          };
          return newItem;
        });
      } else {
        this.nodeArr = [];
      }
      // 出园信息
      let exitParkArr = row.workflows;
      if (exitParkArr.length > 0) {
        exitParkArr.forEach((wfItem) => {
          if (wfItem.status == "12") {
            this.exitParkObj.customerService = wfItem.operatorName;
            this.exitParkObj.customerServiceTime = wfItem.operateTime;
          }
          if (wfItem.status == "14") {
            this.exitParkObj.dispatch = wfItem.operatorName;
            this.exitParkObj.dispatchTime = wfItem.operateTime;
          }
          if (wfItem.status == "16") {
            this.exitParkObj.doorman = wfItem.operatorName;
            this.exitParkObj.doormanTime = wfItem.operateTime;
            this.exitParkObj.doormanPic = wfItem.fileCode;
          }
        });
      } else {
        this.exitParkObj.customerService = "";
        this.exitParkObj.customerServiceTime = "";
        this.exitParkObj.dispatch = "";
        this.exitParkObj.dispatchTime = "";
        this.exitParkObj.doorman = "";
        this.exitParkObj.doormanTime = "";
        this.exitParkObj.doormanPic = "";
      }
      // 入园信息
      let inParkArr = row.workflows;
      if (inParkArr.length > 0) {
        inParkArr.forEach((ipItem) => {
          if (ipItem.status == "2") {
            this.inParkObj.createName = ipItem.operatorName;
            this.inParkObj.createTime = ipItem.operateTime;
          }
        });
      } else {
        this.inParkObj.createTime = "";
        this.inParkObj.createName = "";
      }
    },
    //关闭详情
    handleClosePanel() {
      this.showPanel = false;
    },

    // 查询按钮事件
    searchResult() {
      console.log("---查询--this.searchForm:--", this.searchForm);
      this.page.currentPage = 1;
      this.getProcessList();
    },
    // 重置按钮
    resetQuery() {
      this.dateRange = [];
      this.selectedType = [];
      this.selectedOperateType = [];
      this.searchForm = {
        appointmentPark: null,
        workStatus: null,
        startPlanArrivalTime: null,
        endPlanArrivalTime: null,
        driverName: null,
        frontPlate: null,
        operateTypes: null, // 作业类型
        passTypes: null, // 操作类型
        cabinetNo: null,
        phone: null,
      };
      console.log("---重置--this.searchForm:--", this.searchForm);
      this.getProcessList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getProcessList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getProcessList();
    },
    // 取消 -- 回退当前节点
    cancelRollbackCurrNode() {
      this.rollbackForm.remark = "";
      this.dialogRollbackNode = false;
      this.$refs["refRollbackForm"].clearValidate();
    },
    // 确认 -- 回退当前节点
    confirmRollbackCurrNode() {
      this.$refs.refRollbackForm.validate((validate) => {
        if (validate) {
          this.confirmProcessRollback();
        } else {
          return false;
        }
      });
    },
    // 取消 -- 流程终止
    cancelDiscontinueReview() {
      this.dialogDiscontinueReview = false;
      this.discontinueForm.remark = "";
      this.$refs["refDiscontinueForm"].clearValidate();
    },
    // 确认 -- 流程终止
    confirmDiscontinueReview() {
      this.discontinueObj.remark = this.discontinueForm.remark;
      this.$refs.refDiscontinueForm.validate((validate) => {
        if (validate) {
          this.discontinueObj.remark = this.discontinueForm.remark;
          // 调用流程终止接口
          this.$fetch(
            api.terminationVehicleAppointment,
            this.discontinueObj
          ).then((response) => {
            if (response.success) {
              this.$message({
                message: "流程终止成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.dialogDiscontinueReview = false;
            this.discontinueForm.remark = "";
            this.discontinueObj.remark = "";
            this.$refs["refDiscontinueForm"].clearValidate();
            this.getProcessList();
          });
        } else {
          return false;
        }
      });
    },
    // 流程回退--操作
    handelProcessBack(row) {
      console.log("-handelProcessBack()-workflows:-", row.workflows);
      this.dialogProcessRollback = true;
      let workflow = row.workflows;
      if (workflow.length > 0) {
        this.processRollbackArr = workflow.map((item) => {
          let newItem = {
            ...item,
            nodeWay:
              item.status == "0"
                ? "已申请"
                : item.status == "1"
                ? "待审批"
                : item.status == "2"
                ? "已通过"
                : item.status == "3"
                ? "待签到"
                : item.status == "4"
                ? "已签到"
                : item.status == "5"
                ? "待调度"
                : item.status == "6"
                ? "已调度"
                : item.status == "7"
                ? "待作业"
                : item.status == "8"
                ? "作业中"
                : item.status == "9"
                ? "已完成作业"
                : item.status == "10"
                ? "待客服押车不放行"
                : item.status == "17"
                ? "客服已押车不放行"
                : item.status == "18"
                ? "客服不押车已放行"
                : item.status == "19"
                ? "客服已解压车"
                : item.status == "20"
                ? "客服待解压车"
                : item.status == "26"
                ? "待客服不押车放行"
                : item.status == "27"
                ? "待调度不押车放行"
                : item.status == "11"
                ? "客服出园待审批"
                : item.status == "12"
                ? "客服出园审批已完成"
                : item.status == "13"
                ? "调度出园待审批"
                : item.status == "14"
                ? "调度出园审批已完成"
                : item.status == "15"
                ? "待出园"
                : item.status == "16"
                ? "已出园"
                : item.status == "21"
                ? "待调度押车不放行"
                : item.status == "22"
                ? "调度已押车不放行"
                : item.status == "23"
                ? "调度不押车已放行"
                : item.status == "24"
                ? "调度待解压车"
                : item.status == "25"
                ? "调度已解压车"
                : item.status == "96"
                ? "已取消"
                : item.status == "97"
                ? "已拒绝"
                : item.status == "98"
                ? "已作废"
                : item.status == "99"
                ? "结束"
                : item.status == "95"
                ? "异常终止"
                : "暂无",
            nodeName: item.operatorName ? item.operatorName : "暂无",
            nodeDate: item.operateTime ? item.operateTime : "暂无",
          };
          return newItem;
        });
      } else {
        this.processRollbackArr = [];
      }
    },
    // 子-父 流程回退操作
    processRollbackOpt(pItem) {
      console.log("-processRollbackOpt()-pItem:-", pItem);
      this.processRollbackObj.appointmentUuid = pItem.appointmentUuid;
      this.processRollbackObj.status = pItem.status;
      this.processRollbackObj.remark = pItem.remark;
      this.dialogRollbackNode = true;
    },
    // 取消流程回退操作
    cancelProcessRollback() {
      this.dialogProcessRollback = false;
      this.processRollbackObj.appointmentUuid = "";
      this.processRollbackObj.remark = "";
      this.processRollbackObj.status = 0;
    },
    // 确认流程回退操作
    confirmProcessRollback() {
      if (this.processRollbackObj.appointmentUuid == "") {
        this.dialogProcessRollback = false;
      } else {
        this.processRollbackObj.remark = this.rollbackForm.remark;
        // 调用回退接口
        this.$fetch(
          api.fallbackVehicleAppointment,
          this.processRollbackObj
        ).then((res) => {
          if (res.success) {
            this.$message({
              message: "流程回退成功",
              type: "success",
              duration: 2000,
            });
            this.rollbackForm.remark = "";
            this.dialogRollbackNode = false;
            this.$refs["refRollbackForm"].clearValidate();
            this.dialogProcessRollback = false;
            this.getProcessList();
          } else {
            this.$message({
              message: res.msgContent,
              type: "error",
              duration: 2000,
            });
            this.dialogProcessRollback = false;
            this.getProcessList();
          }
        });
      }
    },
    // 流程终止 -- 操作
    handelProcessDiscontinue(row) {
      console.log("-row:-", row);
      this.discontinueObj.appointmentUuid = row.appointmentUuid;
      this.discontinueObj.remark = row.remark;
      // 流程终止提示
      this.discontinueProcessTips.operateType = row.operateType;
      this.discontinueProcessTips.refAppointmentUuid = row.refAppointmentUuid;
      this.discontinueProcessTips.passType = row.passType;
      this.dialogDiscontinueReview = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.expand {
  width: calc(100% - 250px);
  height: auto;
}

.up {
  width: calc(100% - 250px);
  height: 41px;
  overflow: hidden;
}

.panel-content {
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .img-info-box {
    margin-bottom: 120px;
    position: relative;

    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 18px;
      display: flex;
      width: 100%;

      .el-form-item__content {
        flex: 1;
      }
    }
  }
  .basic-status-box {
    display: flex;
    flex-direction: row;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 18px;
      display: flex;
      width: 100%;

      .el-form-item__content {
        flex: 1;
      }
    }
  }
}

.access-record-container {
  width: 100%;
  height: 86vh;

  .query {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include set_theme_color(background-color, left-menu-bg-color);
    padding: 10px 16px 3px;
    margin-bottom: 15px;

    .el-form-item {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 8px !important;
      vertical-align: top;
    }
  }

  /deep/ .ioc-table {
    width: 100%;
  }
  /deep/ .ioc-table__content {
    padding-top: 15px;
  }
  /deep/ .el-table__body-wrapper {
    width: 100%;
    height: calc(100% - 60px);
    max-height: calc(100% - 60px);
    overflow-y: auto;
  }
  /deep/ .app-side-panel__body {
    overflow-y: auto;
  }
  .el-table__fixed-right-patch {
    display: none;
  }

  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}

.car-info-box {
  margin-bottom: 148px;
  position: relative;

  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 18px;
    display: flex;
    width: 100%;

    .el-form-item__content {
      flex: 1;
    }
  }
}
</style>
